import CardModifierComponent from 'Component/Level/CardModifier';
import AutoCollectModifierBehavior from 'State/Card/ModifierBehavior/AutoCollectModifierBehavior';
import BaseModifierBehavior from 'State/Card/ModifierBehavior/BaseModifierBehavior';
import BombModifierBehavior from 'State/Card/ModifierBehavior/BombModifierBehavior';
import ConnectedModifierBehavior from 'State/Card/ModifierBehavior/ConnectedModifierBehavior';
import FogModifierBehavior from 'State/Card/ModifierBehavior/FogModifierBehavior';
import IceModifierBehavior from 'State/Card/ModifierBehavior/IceModifierBehavior';
import LevelAttemptsModifierBehavior from 'State/Card/ModifierBehavior/LevelAttemptsModifierBehavior';
import LoweringModifierBehavior from 'State/Card/ModifierBehavior/LoweringModifierBehavior';
import PickaxeModifierBehavior from 'State/Card/ModifierBehavior/PickaxeModifierBehavior';
import RisingModifierBehavior from 'State/Card/ModifierBehavior/RisingModifierBehavior';
import RopeModifierBehavior from 'State/Card/ModifierBehavior/RopeModifierBehavior';
import TNTModifierBehavior from 'State/Card/ModifierBehavior/TNTModifierBehavior';
import ToStackModifierBehavior from 'State/Card/ModifierBehavior/ToStackModifierBehavior';
import BaseCardModifierHandler from 'System/Card/Handler/Modifiers/BaseCardModifierHandler';
import ConnectedModifierHandler from 'System/Card/Handler/Modifiers/ConnectedModifierHandler';
import FogModifierHandler from 'System/Card/Handler/Modifiers/FogModifierHandler';
import RopeModifierHandler from 'System/Card/Handler/Modifiers/RopeModifierHandler';
import TNTModifierHandler from 'System/Card/Handler/Modifiers/TNTModifierHandler';
import TomatoModifierHandler from 'System/Card/Handler/Modifiers/TomatoModifierHandler';
import { CardModifierType } from './CardModifierType';
import BombModifier from './Modifier/Bomb';
import CardModifier from './Modifier/CardModifier';
import ConnectedModifier from './Modifier/Connected';
import FogModifier from './Modifier/Fog';
import IceModifier from './Modifier/Ice';
import LoweringModifier from './Modifier/Lowering';
import PickaxeModifier from './Modifier/Pickaxe';
import RisingModifier from './Modifier/Rising';
import RopeModifier from './Modifier/Rope';
import TNTModifier from './Modifier/TNT';
import RewardModifierBehavior from 'State/Card/ModifierBehavior/RewardModifierBehavior';
import { TNTModifierLayout } from 'Layouts/Level/Cards/Modifiers/TNTModifierLayout';
import { Layout } from 'Utility/layout/LayoutHelper';
import { Constructor } from 'Utility/Types';

export function getCardModifierHandler(modifier: CardModifier) {
    const modifierComponent = modifier.getComponent(CardModifierComponent);
    return new ModifierTypeMap[modifierComponent.type].handler(modifier);
}

export const ModifierTypeMap = {
    [CardModifierType.bomb]: {
        prototype: BombModifier,
        behavior: BombModifierBehavior,
        handler: TomatoModifierHandler,
    },
    [CardModifierType.rising]: {
        prototype: RisingModifier,
        behavior: RisingModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.lowering]: {
        prototype: LoweringModifier,
        behavior: LoweringModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.ice]: {
        prototype: IceModifier,
        behavior: IceModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.pickaxe]: {
        prototype: PickaxeModifier,
        behavior: PickaxeModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.rope]: {
        prototype: RopeModifier,
        behavior: RopeModifierBehavior,
        handler: RopeModifierHandler,
    },
    [CardModifierType.fog]: {
        prototype: FogModifier,
        behavior: FogModifierBehavior,
        handler: FogModifierHandler,
    },
    [CardModifierType.reward]: {
        prototype: CardModifier,
        behavior: RewardModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.connected]: {
        prototype: ConnectedModifier,
        behavior: ConnectedModifierBehavior,
        handler: ConnectedModifierHandler,
    },
    [CardModifierType.tnt]: {
        prototype: TNTModifier,
        behavior: TNTModifierBehavior,
        handler: TNTModifierHandler,
        layout: TNTModifierLayout,
    },
    [CardModifierType.auto_collect]: {
        prototype: CardModifier,
        behavior: AutoCollectModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.to_stack]: {
        prototype: CardModifier,
        behavior: ToStackModifierBehavior,
        handler: BaseCardModifierHandler,
    },
    [CardModifierType.level_attempts]: {
        prototype: CardModifier,
        behavior: LevelAttemptsModifierBehavior,
        handler: BaseCardModifierHandler,
    },
};
